import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const SectionDescription = ({ className, description }) => (
  <div className={classNames(styles.description, className)}>
    {description}
  </div>
);

SectionDescription.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
};

export default SectionDescription;



// WEBPACK FOOTER //
// src/components/shared/SectionDescription/index.jsx